import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getMedicationSettings } from '@api/medications';
import { IMedicationSettings } from '@interfaces/medications';

export const handleGetMedicationSettings = createAsyncThunk<
  AxiosResponse<IMedicationSettings>,
  void
>('getMedicationSettings', getMedicationSettings);
